import Cookies from 'js-cookie';
import { create } from 'zustand';

export interface AuthState {
    user: { name: string, phone: string } | null;
    sessionId: string | null;
    licenceId: string | null;
    setLicenceId: (id: string) => void
    setAuthFromUrl: (sessionId: string, licenceId: string) => void;
}
const getInitialUser = () => {
    try {
        const userCookie = Cookies.get('user');
        if (!userCookie) return null;
        const parsed = JSON.parse(userCookie);
        return Array.isArray(parsed) ? parsed[0] : parsed;
    } catch {
        return null
    }
}

export const useAuthStore = create<AuthState>((set) => ({
    user: getInitialUser(),
    sessionId: Cookies.get('sessionId') || null,
    licenceId: localStorage.getItem('licence_id') || null,

    setLicenceId: (id: string) => {
        if (!id) return;
        localStorage.setItem('licence_id', id);
        set({ licenceId: id });
    },
    setAuthFromUrl: (sessionId: string, licenceId: string) => {
        if (sessionId) {
            Cookies.set('sessionId', sessionId, { expires: 7 });
        }
        if (licenceId) {
            localStorage.setItem('licence_id', licenceId);
        }
        set({ sessionId: sessionId || null, licenceId: licenceId || null });
    }
}));